import { FileUploader, TronLogoFileUploader } from './file-uploader';
import { getApiUrl } from './common';
import Cart from './cart';

export class CartFileUploader {

    init(cart: Cart, fromAjaxCall: boolean): void {
        const baseElement = cart.getBaseElement();
        const itemsWithFileUpload = Array.from(
            baseElement.querySelectorAll('[data-file-upload]')
        );

        if (itemsWithFileUpload.length === 0) {
            return;
        }

        const firstItem = itemsWithFileUpload[0] as HTMLElement;

        if (firstItem && firstItem.dataset.tronLogoActive) {
            if (!fromAjaxCall) {
                new TronLogoFileUploader(() => cart.reloadPage());
            }
            return;
        }

        const apiUrl = getApiUrl();
        itemsWithFileUpload.forEach(i => {
            const element = i as HTMLElement;
            const fileInput = i.querySelector('[data-action="FileUpload"]');
            if(!fileInput) return;
            const itemId = element.dataset.productId;
            const url = `${apiUrl}/cart/${itemId}/file`;
            new FileUploader(fileInput, url, () => cart.reloadPage());
        });
    }
}
